import React, { PureComponent, Fragment } from 'react'
import styled from 'styled-components'

const PlatformsWrapper = styled.div`
  :hover {
    box-shadow: 0 10px 35px 0 rgba(0, 0, 0, 0.1);
    transition: 0.2s linear;
    z-index: 1000;
  }
  &:hover p:nth-child(2) {
    transform: scale(1,1);

  }
  &:hover img {
  transform: scale(1.2,1.2);
  transition: 0.5s linear;


  }

  display: flex;
  position: relative;
  flex-direction: column;
  border: 1px solid #f0ecec;
  justify-content: center;
  align-items: center;
  width: 14.285%;
  background: white;
  padding: 60px 35px;
  @media (max-width: 992px) {
    width: 20%;
  }
  @media (max-width: 768px) {
    width: 33.333%;
  }
  @media (max-width: 520px) {
    width: 50%;
  }
  & > img {
    height: 46px;
    width: auto;
    transition: 0.5s linear;
  }
  & > p:nth-child(2) {
    font-size: 21px;
    font-weight: normal;
    line-height: 1.52;
    text-align: center;
    color: #333333;
    padding: 30px 0 15px;
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fffffff5;
    transition: all 0.5s;
    transform: scale(0,0);
  }
  & > p:nth-child(3) {
    max-width: 312px;
    font-size: 16px;
    font-weight: 300;
    line-height: 1.63;
    letter-spacing: 0.1px;
    text-align: center;
    margin: 0;
  }
  @media (max-width: 768px) {
    // box-shadow: 0 10px 35px 0 rgba(0, 0, 0, 0.1);
    // margin-bottom: 20px;
    & > p:nth-child(2) {
      font-size: 24px !important;
      font-weight: normal !important;
      line-height: 1.33 !important;
      letter-spacing: normal !important;
      padding: 20px 0 10px;
    }
    & > p:nth-child(3) {
      font-size: 14px !important;
      font-weight: normal !important;
      line-height: 1.86 !important;
      letter-spacing: 0.1px !important;
      width: 100%;
    }
  }
`

export class Platforms extends PureComponent {
  render() {
    return (
      <Fragment>
        <PlatformsWrapper>
          <img src={this.props.imageUrl} alt={this.props.title} />
          <p>{this.props.title}</p>
        </PlatformsWrapper>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Platforms.js